import './error.scss'
import { Link } from 'react-router-dom'
import { ReactComponent as SearchIcon } from '../../../assets/search.svg'
import ContentState from '../../../stores/ContentState'
import GlobalState from '../../../stores/GlobalState'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { FooterSearch } from '../../Footer'

const Error = observer(() => {
  const mainPage = GlobalState.currentLocale.lang.includes('ру')
    ? 'Главная'
    : GlobalState.currentLocale.lang.includes('En')
    ? 'Main'
    : 'Головна'

  const [links, setLinks] = useState<any>([])

  useEffect(() => {
    if (!ContentState.menu) return

    setLinks([
      {
        title: mainPage,
        link: '/',
      },
      ...ContentState.menu!.list,
    ])
  }, [ContentState.menu])

  if (!ContentState.nofound || !ContentState.menu) return <></>

  return (
    <div className="error">
      <div className="error__content">
        <p
          className="error__subtitle"
          dangerouslySetInnerHTML={{ __html: ContentState.nofound?.subtitle }}
        ></p>
        <p
          className="error__title"
          dangerouslySetInnerHTML={{ __html: ContentState.nofound?.title }}
        ></p>
        <p
          className="error__text"
          dangerouslySetInnerHTML={{ __html: ContentState.nofound?.text }}
        ></p>
      </div>
      <div className="error__bottom">
        <div className="error__bottom-links">
          {links.map((link: any, i: number) => {
            return (
              <Link to={link.link} className="error__bottom-link" key={i}>
                <span>{link.title}</span>
              </Link>
            )
          })}
        </div>
        <FooterSearch />
      </div>
    </div>
  )
})

export default Error
